import responses from './responsesSaga';
import userDelegate from './userDelegateSaga';
import event from './eventSaga';
import { all } from 'redux-saga/effects';
import search from './searchSaga';
import emailDelivery from './emailDeliverySaga';
import accountOwner from './accountOwnerSaga';
import user from './userSagas';
import tenantStats from './tenantStatsSaga';
import accountAdmins from './accountAdminsSaga';
import accountBasics from './accountBasicsSaga';
import configurationDefaults from './configurationDefaultsSaga';
import authentication from './authenticationSaga';
import selfLaunchAllowed from './selfLaunchAllowedSaga';
import roster from './rosterSaga';
import logout from './logoutSaga';
import prioritize from './prioritizeSaga';
import aiReportSummary from './aiReportSummarySaga';
import aiReportSummaryV1 from './aiReportSummaryV1Saga';
import { insightsSaga } from '../features/ai-insights/sagas/insights';

// Here, we register our watcher sagas and export as s single generator function (startWorker) as our root Saga

export default function* rootSaga () {
  // @formatter:off
  yield all([
    ...user,
    ...tenantStats,
    ...accountAdmins,
    ...accountBasics,
    ...configurationDefaults,
    ...authentication,
    ...selfLaunchAllowed,
    ...accountOwner,
    ...emailDelivery,
    ...search,
    ...logout,
    ...event,
    ...userDelegate,
    ...roster,
    ...responses,
    ...prioritize,
    ...aiReportSummary,
    ...aiReportSummaryV1,
    insightsSaga(),
    // __REDUX_ABOVE_ME__
  ]);
  // @formatter:on
}
